import { createFileRoute } from "@tanstack/react-router";

import { useMe } from "../features/auth/session";
import { TrackingSettings } from "../features/settings/TrackingSettings";
import { useT } from "../i18n/I18nProvider";

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/iu;

interface TrackingSearch {
  /** The campaign that sent the customer here, so they can go straight back to it. */
  readonly campaign?: string;
}

export const Route = createFileRoute("/app/settings/tracking")({
  validateSearch: (search: Record<string, unknown>): TrackingSearch =>
    typeof search.campaign === "string" && UUID.test(search.campaign)
      ? { campaign: search.campaign }
      : {},
  component: TrackingPage,
});

function TrackingPage() {
  const t = useT();
  const me = useMe();
  const { campaign } = Route.useSearch();
  if (!me.data) return <p>{t("common.loading")}</p>;
  return (
    <>
      {campaign === undefined ? null : (
        <p className="mb-4">
          <a href={`/app/campaigns/${campaign}`}>← {t("settings.tracking.backToCampaign")}</a>
        </p>
      )}
      <h2>{t("settings.tracking.title")}</h2>
      <TrackingSettings key={me.data.activeOrganizationId ?? "none"} me={me.data} />
    </>
  );
}
